module.exports = __webpack_public_path__ + "img/img8.3d610d08.png";